import { createFileRoute } from "@tanstack/react-router"

import StyleGuidePage from "@/admin/style/page"

export const Route = createFileRoute("/_admin/admin/style")({
  component: StyleGuidePage,
})
